import {Color} from '@/Types/Enums/Color'
import {type RotationDocumentation} from '@/Types/Periods/Rotations/Documentation/RotationDocumentation'

export const getRotationDocumentationStatusColor = (rotation:RotationDocumentation):Color => {
	if(rotation.is_pending){
		return Color.Yellow
	}
	if(rotation.is_accepted){
		return Color.Green
	}
	if(rotation.is_rejected){
		return Color.Red
	}
	return Color.Neutral
}